// extracted by mini-css-extract-plugin
export default {"configWrapper":"form-builder-card-config_configWrapper__3Owqq"};